import { useDesktopView } from 'utils/hooks/useDesktopView'

export const usePemberitahuanDesktopView = () =>
  useDesktopView('pemberitahuan-desktop-view-enabled')
